import React from 'react';
import { Text, View } from 'react-native';
import Input from '@/components/General/inputs/Input'
import DatePickerInput from '@/components/General/inputs/DatePickerInput'
import SelectInput from '@/components/General/inputs/SelectInput';
import ToggleInput from '@/components/General/inputs/ToggleInput';
import FileInput from '@/components/General/inputs/FileInput';
import Toggle from '@/components/General/inputs/Toggle';
import { StyleSheet } from 'react-native-unistyles';

const CustomField = ({ fieldType, onUpdate, options, onBlur = () => {}, required = false }) => {

    return(
        <View>
            {(() => {
                switch(fieldType){
                    case "Text":
                        return <Input
                            type={options.type || "default"}
                            onBlur={onBlur}
                            title={options.title}
                            value={options.value}
                            onUpdate={onUpdate}
                            required={required}
                            secureTextEntry={options.secureTextEntry}
                        />
                    case "Long Text":
                        return <Input
                            type={options.type || "default"}
                            onBlur={onBlur}
                            title={options.title}
                            value={options.value}
                            onUpdate={onUpdate}
                            required={required}
                            secureTextEntry={options.secureTextEntry}
                            multiline={true}
                        />
                    case "Date":
                        return <DatePickerInput
                            title={options.title}
                            onBlur={onBlur}
                            mode={"date"}
                            value={options.value}
                            onUpdate={onUpdate}
                            required={required}
                            emptyText={options.emptyText}
                        />
                    case "Datetime":
                        return <DatePickerInput
                            title={options.title}
                            onBlur={onBlur}
                            mode={"datetime"}
                            value={options.value}
                            onUpdate={onUpdate}
                            required={required}
                            emptyText={options.emptyText}
                        />
                    case "Number":
                        return <Input
                            type="number-pad"
                            onBlur={onBlur}
                            title={options.title}
                            value={options.value}
                            onUpdate={onUpdate}
                            required={required}
                            secureTextEntry={options.secureTextEntry}
                            numbersOnly={options.numbersOnly}
                        />
                    case "Checkbox":
                        return <View style={styles.checkbox}>
                            <Text style={styles.checkBoxLabel}>{options.title}</Text>
                            <Toggle
                                onValueChange={onUpdate}
                                value={options.value}
                            />
                    </View>
                    case "Dropdown":
                        return <SelectInput
                            options={options.options}
                            title={options.title}
                            value={options.value}
                            onUpdate={onUpdate}
                            required={required}
                        />
                    case "Multiselect":
                        return <ToggleInput
                            title={options.title}
                            items={options.options}
                            selectedValues={options.value}
                            onItemChanged={(selectedItem, new_value) => {
                                const items = options.value ? options.value : []

                                const index = items.indexOf(selectedItem)
                                index == -1 ? (new_value && items.push(selectedItem)) : (!new_value && items.splice(index, 1))
                                onUpdate(items)
                            }}
                            onSelectAll={(formatted, selectAll) => {
                                onUpdate(selectAll ? formatted.map(item => item.value) : [])
                            }}
                            itemsPerRow={2}
                            enableSelectAll
                        />
                    case "File Upload":
                        return <FileInput
                            showPhotoLibrary
                            title={options.title}
                            assets={options.value}
                            onSelect={onUpdate}
                            onRemoveAsset={() => {
                                onUpdate(null);
                            }}
                        />
                    default:
                        return <View></View>
                }
            })()}
        </View>
    )
}

const styles = StyleSheet.create(({colors, shadows, roundness}) => ({
    checkbox: {
        height:44,
        minHeight:44,
        paddingHorizontal:15, 
        flexDirection:"row", 
        alignItems:"center", 
        justifyContent:'space-between', 
        marginVertical:10, 
        borderRadius:roundness.md,
        backgroundColor:colors.inputBackground,
        boxShadow:shadows.input,
    },
    checkBoxLabel: {
        color:colors.text, 
        fontSize:14
    }
}))

export default React.memo(CustomField)